module.exports = __webpack_public_path__ + "static/media/AW_250-Mama_mobile_hero_fr.4f885345.jpg";